/**
 * Legacy-Redirect: /user_wallets → /wallets
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/user_wallets')({
  beforeLoad: () => {
    throw redirect({ to: '/wallets', replace: true })
  },
  component: () => null,
})
